import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../../features/langSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LANGUAGE_OPTIONS, normalizeLanguageCode } from '../../utils/language';

const Language = ({ isSidebar, darkText, options = LANGUAGE_OPTIONS }) => {
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [selected, setSelected] = useState(normalizeLanguageCode(localStorage.getItem('lang')));
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setLanguage({ lng: selected }));
  }, [selected, dispatch]);

  // Keep the label in sync with the language actually rendered. Pages that pick
  // their own language on mount (the ad landing pages default to German) change
  // i18n after this component's first render, so seeding from localStorage alone
  // leaves the switcher showing a language the page is not in.
  useEffect(() => {
    setSelected(normalizeLanguageCode(i18n.language));
  }, [i18n.language]);

  const updateUrlWithLang = (lng) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('lang', normalizeLanguageCode(lng));
    navigate({ search: newSearchParams.toString() });
  };

  const changeLanguage = (e, lng) => {
    e.preventDefault();

    const normalizedLanguage = normalizeLanguageCode(lng);

    localStorage.setItem('lang', normalizedLanguage);
    i18n.changeLanguage(normalizedLanguage);
    updateUrlWithLang(normalizedLanguage);

    setSelected(normalizedLanguage);

    dispatch(setLanguage({ lng: normalizedLanguage }));

    setIsLangMenuOpen(!isLangMenuOpen);
  };
  const toggleLangMenu = (e) => {
    e.preventDefault();
    setIsLangMenuOpen(!isLangMenuOpen);
  };

  return (
    <>
      <li className={`nav-item dropdown m-lang t-list-none ${isSidebar ? '!t-m-0' : ''}`}>
        <a
          className={`login ${isLangMenuOpen ? 'show' : ''}`}
          href="#"
          id="dropdownId"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded={`${isLangMenuOpen ? 'true' : 'false'}`}
          onClick={(e) => toggleLangMenu(e)}
        >
          <span
            className="t-font-sans"
            style={{
              textTransform: 'uppercase',
              color: (isSidebar || darkText) ? '#103642' : '#ffffff',
              fontWeight: 'bold',
            }}
          >{selected}</span>{' '}
          <i className={`fas fa-sort-down ${(isSidebar || darkText) ? 't-text-[#103642]' : 't-text-white'} `}></i>
        </a>
        <div
          className={`dropdown-menu ${isSidebar ? '!t-bottom-full !t-top-auto !t-left-0 !t-right-auto' : '!t-right-0'} ${
            isLangMenuOpen ? 'show' : ''
          }`}
          aria-labelledby="dropdownId"
          {...(isLangMenuOpen ? "data-bs-popper='none'" : '')}
        >
          {options.map((language) => (
            <a
              key={language.code}
              className="dropdown-item t-font-sans !t-font-normal"
              href="#"
              onClick={(e) => changeLanguage(e, language.code)}
            >
              <i className={`flag-icon flag-icon-${language.flagCode}`}></i> {language.label}
            </a>
          ))}
        </div>
      </li>
    </>
  );
};

export default Language;
